export default function ({ store, route, redirect }) {
  // If the user is not authenticated
  const fullPath = route.fullPath
  // 暂时下线C1 C2 活动页面, home/:country 也是带有优惠券的
  if (/^\/c1|^\/c2|^\/home\/\w+/.test(fullPath)) {
    return redirect('/lp1')
  }
};
